<script>
// 组件渲染函数
import render from '../render/index.js'
import cloneDeep from 'lodash/cloneDeep'
import debounce from 'lodash/debounce'
import merge from 'lodash/merge'
import { evalFn, getCurrentDevice, getDevice } from '../utils/index'
import { track } from '@cbee/bee-sdk-javascript'


import AOS from 'aos'
import '../style/aos.css' 
// import sal from 'sal.js'

function getScheme (scheme) {
  const copyConfig = cloneDeep(scheme)
  const activeDeviceData = copyConfig[this.readDevice || this.countDeviceType] || {}
  const newScheme = merge({}, copyConfig, activeDeviceData)
  return newScheme
}

/**
 * 布局el-form-item
 * data-sal="fade"
   data-sal-delay="600"
   data-sal-duration="2000"
   data-sal-easing="ease-out-back"
 */
const layouts = {
  colFormItem (h, scheme) {
    const currentScheme = getScheme.call(this, scheme) || {}
    const config = currentScheme.__config__
    return (
      <el-col span={config.span}>
        {modeRenderFn.call(this, h, scheme)}
      </el-col>
    )
  },
  rowFormItem (h, scheme) {
    const currentScheme = getScheme.call(this, scheme)
    const config = currentScheme.__config__
    const child = renderChildren.apply(this, arguments)
    const listeners = buildListeners.call(this, scheme)
    return (
      <el-col span={config.span}>
        <el-row gutter={scheme.gutter}>
          <render
            headers={this.headers}
            conf={scheme}
            readDevice={this.readDevice || this.countDeviceType}
            {...{ on: listeners }}
            mode={this.mode}
            style="box-sizing: border-box"
          >
            {child}
          </render>
        </el-row>
      </el-col>
    )
  },
  mutilFormPage (h, scheme) {
    const currentScheme = getScheme.call(this, scheme)
    const config = currentScheme.__config__
    const listeners = buildListeners.call(this, scheme)
    const stepContentList = renderContentStep.apply(this, arguments)
    return (
      <el-col span={config.span}>
        <render child={stepContentList} conf={scheme} {...{ on: listeners }} mode={this.mode} readDevice={this.readDevice || this.countDeviceType}></render>
      </el-col>
    )
  }
}

function modeRenderFn (h, scheme) {
  const listeners = buildListeners.call(this, scheme)
  return (
    <render conf={scheme} mode={this.mode} {...{ on: listeners }} readDevice={this.readDevice || this.countDeviceType} />
  )
}

/**
 * el-form渲染
 */
function renderFrom (h) {
  const { formConfCopy } = this
  const style = {
    'min-height': '100%',
    background: formConfCopy.backgroundImage ? `url(${formConfCopy.backgroundImage}) center center / auto 100% no-repeat` : '',
    'font-size': 0,
    backgroundColor: formConfCopy.backgroundColor
  }
  return (
    <el-row gutter={formConfCopy.gutter} style={style}>
      {renderFormItem.call(this, h, formConfCopy.fields)}
    </el-row>
  )
}

/**
 * 每个组件渲染
 */
function renderFormItem (h, elementList) {
  return elementList.map(scheme => {
    const config = scheme.__config__
    const layout = layouts[config.layout]
    if (layout) {
      // const copyScheme = cloneDeep(scheme)
      // const activeDeviceData = copyScheme[this.readDevice || this.countDeviceType] || {}
      const newScheme = scheme //merge({}, copyScheme, activeDeviceData)
      return layout.call(this, h, newScheme)
    }
    return false
  })
}

/**
 * 渲染步骤内容
 */
function renderContentStep (h, scheme) {
  const config = scheme.__config__
  const steps = scheme.__slot__.options
  return steps.map((step, i) => {
    if ((config.tag === 'el-tabs' || config.tag === 'advance-tabs') && config.defaultValue === step.name) {
      return renderFormItem.call(this, h, step.children)
    }
  })
}

/**
 * 容器组件渲染
 */
function renderChildren (h, scheme) {
  const config = scheme.__config__
  if (!Array.isArray(config.children)) return null
  return renderFormItem.call(this, h, config.children)
}

/**
 * 设置值
 */
function setValue (event, config, scheme, flag) {
  !flag && this.$set(config, 'defaultValue', event)
  this.$set(this[this.formConf.formModel], scheme.__vModel__, event)
}

/**
 * 设置监听属性
 */
function buildListeners (scheme) {
  const config = scheme.__config__
  const methods = scheme.__methods__ || {}
  const listeners = {}

  Object.keys(methods).forEach(key => {
    const fn = methods[key]
    listeners[key] = event => evalFn(fn).call(this, event, scheme, this.domain)
  })
  // 响应 render.js 中的 vModel $emit('input', val)
  listeners.input = event => setValue.call(this, event, config, scheme)

  listeners.AddFastSiteEdit = event => {
    this.$emit('AddFastSiteEdit', { ...event, scheme })
  }

  return listeners
}

export default {
  name: 'Parser',
  props: {
    formConf: {
      type: Object,
      required: true,
      default () {
        return {}
      }
    },
    domain: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: 'view'
    },
    readDevice: {
      type: String,
      default: null
    }
  },
  provide () {
    return {
      domain: this.domain,
      globalScrollAnimation: this.formConf.globalScrollAnimation || false
    }
  },
  data () {
    const data = {
      formConfCopy: cloneDeep(this.formConf),
      [this.formConf.formModel]: {},
      [this.formConf.formRules]: {},
      resizeObserver: null,
      countDeviceType: getCurrentDevice()
    }
    return data
  },
  created () {
    track('CmsSdkEngine') // 采集曝光
  },
  components: {
    render
  },
  render (h) {
    return renderFrom.call(this, h)
  },
  mounted () {
    this.resizeObserver = new ResizeObserver(debounce((entries) => {
      entries.forEach((entry) => {
        if (entry.target.tagName === 'BODY') {
          const width = entry.contentRect.width
          this.countDeviceType = getDevice(width)
        }
      })
    }, 200))
    this.resizeObserver.observe(document.body)
    this.initAnimation()
  },
  beforeDestroy () {
    this.resizeObserver.disconnect()
  },
  methods: {
    initAnimation () {
      if(!this.formConf.globalScrollAnimation) return
      AOS.init({
        offset: 0
      })
    },
    // fix：临时解决当滚动元素不是基于body时，aos动画不生效的问题！
    updateAnimationEvent (e) {
      if(!this.formConf.globalScrollAnimation) return
      AOS.init({
        offset: -1 * e.target.scrollTop,
        duration: 1000
      })
      AOS.refresh()
    },
  }
}
</script>
